import { Vue, BitrixVue } from 'ui.vue';
import './style.css';
export class ContragentList {
	result = null;
	params = null;
	componentName = null;
	constructor ({ result, params, componentName }) {
		this.result = result;
		this.params = params;
		this.componentName = componentName;
		if (this.params?.COMPONENT_UID) {
			this.rootNode = document.getElementById(this.params.COMPONENT_UID);
		}
		if (this.rootNode) {
			this.init();
		}
		if (BX.SidePanel != undefined) {
			BX.SidePanel.Instance.bindAnchors({
				rules: [{
					condition: [
						// "/personal/orders/?ID=",
						// this.params.PATH_TO_DETAIL.replace(/#ID#/i,'*'),
						"/personal/contragents/",
						"/personal/contragents/(.*)",
					],
					// loader: "tasks:view-loader",
					//Игноривать ссылки, содержащие следующие параметры в Query String
					stopParameters: [
						// "actions="
					],
					//Опции, с которыми откроется слайдер
					options: {
						// printable: true,
						cacheable: true,
						contentClassName: "light-sidepanel",
						width: 800,
						// animationDuration: 1000,
						// width: 500,
						label: {
							class: 'dark',
							text: "Контрагенты ",
							color: "#000000", //цвет текста
							bgColor: "#ebf1f4", //цвет фона
							opacity: 100 //прозрачность фона
						},
						events: {
							// onOpenStart: BX.proxy(this.SidePanelOpenStart, this),
							// onBeforeOpenComplete: function (event) {},
							// onCloseStart: function (event) {},
							// onBeforeCloseComplete: function (event) {},
							// onLoad: BX.proxy(this.SidePanelLoad, this),
							// onDestroy: function (event) {},
							// onEscapePress: function (event) {},
						}
					},
					mobileFriendly: true
				},
				]
			});
		}
	}
	init() {
		const contragents = this.result?.ITEMS;
		const params = this.params;
		this.app = BitrixVue.createApp({
			el: this.rootNode,
			name: 'sale.contragent.list',
			store: userStore,
			data() {
				return {
					params: params,
					searchMinCount: 5, // TODO Перенести в параметры шаблона
					toggleOverlayNode: null,
					searchQuery: '',
					defContragents: contragents,
					isContragentBonusListOpen: false,
					isContragentListOpen: false,
					bonusList: [],
				};
			},
			computed: {
				localize() {
					return Vue.getFilteredPhrases('');
				},
				cart(state) {
					return state.$store?.getters['basket/basket'];
				},
				cartContragentId(state) {
					return state.cart.CONTRAGENT_ID;
				},
				contragentList(state) {
					return state.defContragents ?? state.$store?.getters['getContragents'];
				},
				contragentListCount(state) {
					return state.contragentList ? Object.keys(state.contragentList).length : 0;
				},
				filteredContragentList(state) {
					if (!state.searchQuery) {
						return Object.values(state.contragentList);
					}
					const query = state.searchQuery?.toLowerCase();
					return Object.values(state.contragentList)?.filter(contragent => {
						return contragent.NAME?.toLowerCase()?.includes(query);
					});
				},
				contragentsGrouped(state) {
					const groups = {};
					for (const i in state.filteredContragentList) {
						if (Object.prototype.hasOwnProperty.call(state.filteredContragentList, i)) {
							const contragent = state.filteredContragentList[i];
							const source = contragent.SOURCE?.toUpperCase();
							if (!groups[source]) {
								groups[source] = [];
							}
							groups[source].push(contragent);
						}
					}
					return groups;
				},
				contragentsGroupedCount(state) {
					return Object.keys(state.contragentsGrouped)?.length;
				},
				activeContragent(state) {
					const [firstKey, firstValue] = Object.entries(state.contragentList)[0];
					return state.contragentList[state.cartContragentId] ?? state.contragentList[firstKey];
				},
				activeContragentId: {
					get() {
						return this.activeContragent.ID != undefined ? this.activeContragent.ID : false;
					},
					set(val) {
						this.$store.commit('basket/setContragentId', val);
					}
				},
				componentSubmoduleList(state) {
					return state?.$store.getters?.getComponentSubmodule;
				},
				totalBonusValue: (state) => {
					return state.bonusList?.reduce((acc, bonus) => {
						const value = parseFloat(bonus?.VALUE);
						const bonusDate = new Date(bonus?.TIMESTAMP * 1000);
						const curDate = new Date();
						if (!isNaN(value) && bonusDate >= curDate) {
							acc += value;
						}
						return acc;
					}, 0);
				},
				totalBonusValueCurrency: (state) => {
					return BX?.Currency?.currencyFormat(state.totalBonusValue, state.cartCurrency, false)
						?.replace(/&nbsp;/g, ' ');
				},
				showGrouped: (state) => state.params?.SHOW_GROUPED,
				showBonus: (state) => state.params?.SHOW_BONUS && state.totalBonusValue > 0,
				showSearch: (state) => state.params?.SHOW_SEARCH && state.contragentListCount >= state.searchMinCount,
				showSelector: (state) => state.params?.SHOW_SELECTOR && state.contragentListCount >= 2,
				showPopupSelector: (state) => state.params?.SHOW_POPUP_SELECTOR
					&& state.showSelector
					&& state.contragentListCount >= state.searchMinCount,
				rootClass: () => 'active-contragent',
				activeContragentName: (state) => state.activeContragent.NAME,
				activeContragentClass: (state) => state.activeContragent.ID ? 'active' : '',
				activeContragentTitle: (state) => state.localize?.CONTRAGENT_ACTIVE
					?.replace('#TITLE#', state.activeContragentName),
				contragentIconClass: (state) => state.contragentListCount > 1 ? 'fas fa-user-circle' : 'fas fa-user-circle',
				contragentListUrl: (state) => state.params?.CONTRAGENTS_PAGE_URL,
				contragentBtnListTitle: (state) => state.localize?.CONTRAGENT_CHANGE_TO
					?.replace('#TITLE#', state.activeContragent.NAME),
				contragentSwitchHeader: (state) => state.localize?.CONTRAGENT_CHANGE_TO
					?.replace('#TITLE#', ''),
				bonusHeader: (state) => state.localize?.BONUS_LIST_HEADER
					?.replace('#TOTAL_VALUE#', state.totalBonusValue),
				bonusBtnListTitle: (state) => state.localize?.BONUS_LIST_TITLE
					?.replace('#TOTAL_VALUE#', state.totalBonusValue)
			},
			created() {
				document.addEventListener('DOMContentLoaded', () => {
					this.requestBonus();
				});
				BX.addCustomEvent("OnAfterContragentChange", BX.delegate((event) => {
					this.requestBonus();
				}, this));
			},
			methods: {
				setBonus: function (bonusList) {
					this.bonusList = [...this.bonusList, ...bonusList];
				},
				clearBonus: function () {
					this.bonusList.length = 0;
				},
				requestBonus: function () {
					if (!this.activeContragentId) return;
					const key = 'BonusList-' + this.activeContragentId;
					try {
						const localBonus = JSON.parse(sessionStorage.getItem(key));
						if (localBonus && localBonus.time >= Date.now() && localBonus.list?.length) {
							this.setBonus(localBonus.list);
						}
					} catch (error) {
						console.error(error);
					}
					if (!this.bonusList?.length) {
						const fetchKey = 'fetch' + key;
						if (!window[fetchKey]) {
							window[fetchKey] = BX.ajax.runAction('germes:multibasket.bonus.getList', {
								data: {
									contragentId: this.activeContragentId
								}
							});
						}
						window[fetchKey].then(response => {
							if (response.errors?.length) throw response;
							this.setBonus(response.data);
							const val = JSON.stringify({
								time: Date.now() + 10 * 60 * 1000, // 10 минут
								list: this.bonusList
							});
							sessionStorage?.setItem(key, val);
							return response;
						}).catch(response => {
							console.error(response);
							this.clearBonus();
							return response;
						}).then(response => {
							delete (window[fetchKey]);
							return response;
						});
					}
				},
				setContragent: function (contragent_id) {
					this.activeContragentId = contragent_id;
					this.closeContragentList();
					this.closeContragentBonusList();
				},
				toggleContragentList: function () {
					this.isContragentListOpen = !this.isContragentListOpen;
					this.toggleOverlay();
					if (this.isContragentListOpen) {
						this.$nextTick(() => {
							this.$refs.searchInput?.focus();
						});
					}
				},
				toggleOverlay: function () {
					if (!this.toggleOverlayNode) {
						this.toggleOverlayNode = document.getElementsByClassName('popup-window-overlay')[0];
						if (!this.toggleOverlayNode) {
							this.toggleOverlayNode = document.createElement('div');
							this.toggleOverlayNode.className = 'popup-window-overlay';
							document.body.appendChild(this.toggleOverlayNode);
							this.toggleOverlayNode = document.getElementsByClassName('popup-window-overlay')[0];
						}
					}
					if (this.isContragentListOpen) {
						this.toggleOverlayNode.style.display = 'block';
					} else {
						this.toggleOverlayNode.style.display = 'none';
					}
				},
				closeContragentList: function () {
					setTimeout(() => {
						this.isContragentListOpen = false;
					}, 100);
				},
				filterContragentList: function (event) {
				},
				filterContragentListClear: function () {
					this.searchQuery = '';
				},
				openContragentBonusList: function () {
					this.isContragentBonusListOpen = !this.isContragentBonusListOpen;
				},
				closeContragentBonusList: function () {
					this.isContragentBonusListOpen = false;
				},
				isActiveContragent: function (contragent) {
					return this.activeContragentId == contragent.ID;
				},
				contragentSwitchGroupTitle: function (source) {
					return this.localize?.CONTRAGENTS_GROUP
						?.replace('#TITLE#', source);
				},
				contragentSwitchClass: function (contragent) {
					return [(this.isActiveContragent(contragent) ? 'active' : '')];
				},
				contragentSwitchTitle: function (contragent) {
					return this.isActiveContragent(contragent)
						? this.activeContragentTitle
						: this.localize?.CONTRAGENT_CHANGE_TO?.replace('#TITLE#', contragent.NAME);
				},
				bonusRowText: function (bonus) {
					let bonusRow = '';
					if (bonus) {
						if (bonus.NAME) {
							bonusRow += `${bonus.NAME}`;
						}
						if (bonus.DATE) {
							bonusRow += ` (${this.localize?.BONUS_ITEM_UNTIL} ${bonus.DATE})`;
						} else {
							bonusRow += ` (${this.localize?.BONUS_ITEM_NO_UNTIL})`;
						}
						if (bonus.VALUE) {
							bonusRow += `<br/><b>${this.localize?.BONUS_ITEM_VALUE
								?.replace('#BONUS_VALUE#', bonus.VALUE)}</b>`;
						}
					}
					return bonusRow;
				}
			},
			template: `
				<div v-cloak :class='rootClass'>
					<span v-if="componentSubmoduleList">
						<template v-for="componentSubmodule in componentSubmoduleList">
							<component :data-sort="componentSubmodule.sort" :is="componentSubmodule.name"></component>
						</template>
					</span>
					<span v-if="showBonus" class="active_contragent-bonus-list btn-group dropright" @focusout="closeContragentBonusList()">
						<button id="contragents-bonus-dropdown-menu" type="button" aria-haspopup="true" :aria-expanded="isContragentBonusListOpen"
							@click="openContragentBonusList()"
							:title="bonusBtnListTitle"
							class="d-flex justify-content-center btn-link dropdown-toggle-buttom float-none text-color-danger bg-none">
							<span class="h3 wow pulse mb-0 mt-0 bg-none text-color-danger" data-wow-iteration="1000" data-wow-duration="0.5s" data-placement="bottom" style="visibility: visible; animation-duration: 0.5s; animation-name: pulse;">
								<i class="fas fa-gift"></i>
							</span>
						</button>
						<div class="dropdown" v-show="isContragentBonusListOpen" aria-labelledby="contragents-bonus-dropdown-menu">
							<div class="dropdown-header">
								{{bonusHeader}}
							</div>
							<span v-for="bonus in bonusList" class="dropdown-item"
								:data-xml-id="bonus.XML_ID"
								:key="bonus.XML_ID"
								v-html="bonusRowText(bonus)">
							</span>
						</div>
					</span>
					<span v-if="!showSelector" id="contragents-dropdown-menu" class="d-flex btn-link py-1 pl-lg-3 ml-lg-5 border-0 dropdown-toggle-buttom text-lg-right" type="button" aria-expanded="false"
						:title="localize.CHANGE_CONTRAGENT.replace('#CONTRAGENT_NAME#',activeContragent.NAME)">
						<a :href="params.PATH_TO_PROFILE" :title="localize.CONTRAGENTS_PAGE_LINK">
							<i :class="contragentIconClass" class="mr-1 align-content-center"></i>
						</a>
						<a :href="params.PATH_TO_PROFILE" class="selected-contragent-name" :title="localize.CONTRAGENTS_PAGE_LINK">
							<span class="selected-contragent-name-text" v-html="activeContragent.NAME"></span>
						</a>
					</span>
					<span v-else class="contragent-list-dropdown">
						<button id="contragents-dropdown-menu" type="button" aria-haspopup="true" :aria-expanded="isContragentListOpen"
							@click="toggleContragentList()"
							:title="contragentBtnListTitle"
							class="d-flex btn-link py-1 pl-lg-3 ml-lg-5 border-0 dropdown-toggle-buttom text-lg-right">
							<a v-if="contragentListUrl" :href="contragentListUrl" :title="localize.CONTRAGENTS_PAGE_LINK" target="_top">
								<i :class="contragentIconClass" class="mr-1 align-content-center"></i>
							</a>
							<i v-else :class="contragentIconClass" class="mr-1 align-content-center"></i>
							<span class="selected-contragent-name">
								{{activeContragent.NAME}}
							</span>
							<i class="fas fa-angle-down ml-2 align-content-center"></i>
						</button>
						<div v-if="showPopupSelector" class="popup-window" v-show="isContragentListOpen" aria-labelledby="contragents-dropdown-menu">
							<div class="popup-window-titlebar">
								<span class="popup-window-titlebar-text">
									{{contragentSwitchHeader}}
								</span>
								<span v-if="showSearch" class="popup-search list-search">
									<input type="text" placeholder="..."
										ref="searchInput"
										v-model="searchQuery" />
									<button type="clear"
										@click="filterContragentListClear"></button>
								</span>
								<button type="button" class="popup-window-close-icon popup-window-titlebar-close-icon" @click="closeContragentList"></button>
							</div>
							<div class="popup-window-content">
								<ul v-if="contragentsGroupedCount" class="popup-list list">
									<li v-for="contragent in filteredContragentList" class="popup-list-item list-search-item"
										@click="setContragent(contragent.ID)"
										:data-xml-id="contragent.XML_ID"
										:data-source="contragent.SOURCE"
										:key="contragent.XML_ID"
										:class="contragentSwitchClass(contragent)"
										:title="contragentSwitchTitle(contragent)">
										{{contragent.NAME}}
									</li>
								</ul>
								<p v-else-if="searchQuery" class="list_empty">
									Результатов не найдено
								</p>
							</div>
						</div>
						<div v-else class="dropdown" v-show="isContragentListOpen" aria-labelledby="contragents-dropdown-menu" @focusout="closeContragentList()">
							<span class="dropdown-header">
								{{contragentSwitchHeader}}
								<span v-if="showSearch" class="dropdown-search list-search">
									<input type="text" placeholder="..."
										ref="searchInput"
										v-model="searchQuery" />
									<button type="clear"
										@click="filterContragentListClear"></button>
								</span>
							</span>
							<ul v-if="contragentsGroupedCount" class="dropdown-list list">
								<template v-if="showGrouped && contragentsGroupedCount > 1">
									<li v-for="(group, source) in contragentsGrouped" :key="source" class="dropdown-group">
										<!-- Заголовок группы -->
										<div class="dropdown-group-title">
											{{ contragentSwitchGroupTitle(source) }}
										</div>
										<!-- Контрагенты в группе -->
										<ul class="dropdown-list">
											<li v-for="contragent in group" class="dropdown-list-item list-search-item"
												:key="contragent.XML_ID"
												@click="setContragent(contragent.ID)"
												:data-xml-id="contragent.XML_ID"
												:data-source="contragent.SOURCE"
												:class="contragentSwitchClass(contragent)"
												:title="contragentSwitchTitle(contragent)">
												{{ contragent.NAME }}
											</li>
										</ul>
									</li>
								</template>
								<template v-else>
									<li v-for="contragent in filteredContragentList" class="dropdown-list-item list-search-item"
										@click="setContragent(contragent.ID)"
										:data-xml-id="contragent.XML_ID"
										:data-source="contragent.SOURCE"
										:key="contragent.XML_ID"
										:class="contragentSwitchClass(contragent)"
										:title="contragentSwitchTitle(contragent)">
										{{contragent.NAME}}
									</li>
								</template>
							</ul>
							<p v-else-if="searchQuery" class="list_empty">
								Результатов не найдено
							</p>
						</div>
					</span>
				</div>`
		});
	}
}
